import { render, staticRenderFns } from "./biz-relationship.vue?vue&type=template&id=deaf90da&scoped=true"
import script from "./biz-relationship.vue?vue&type=script&lang=js"
export * from "./biz-relationship.vue?vue&type=script&lang=js"
import style0 from "./biz-relationship.vue?vue&type=style&index=0&id=deaf90da&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaf90da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deaf90da')) {
      api.createRecord('deaf90da', component.options)
    } else {
      api.reload('deaf90da', component.options)
    }
    module.hot.accept("./biz-relationship.vue?vue&type=template&id=deaf90da&scoped=true", function () {
      api.rerender('deaf90da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/participant/terminal/form/component/biz-relationship/biz-relationship.vue"
export default component.exports